/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/user/info',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    share : '/api/share/getCode',//网页分享
    invite : '/api/team/invite',//邀请组队
    apply_list : '/api/tyjy/applylist',//申请列表
    share_apply : '/api/share/help',//助力同意
    invite_apply : '/api/team/apply',
    invite_info : '/api/share/getNickName',
    apply_agree : '/api/team/review',//审核同意
    team_info : '/api/team/info',//小队信息
    join_apply : '/api/team/apply',//加入小队申请
    team_create : '/api/team/create',//创建小队
    team_quit : '/api/team/leave',//退出小队
    score_info : '/api/user/score',//积分信息
    task_info : '/api/user/task/dict',//任务信息
    task_apply : '/api/user/task/receive',//任务领奖
    task_team : '/api/other/team/gift',//组队任务
    team_task_apply : '/api/other/team/gift/receive',//小队一键领取
    read : '/api/other/hero/skill',//技能阅读
    read_update : '/api/user/task?taskNo=f1',//阅读完成
}

//任务信息
// k1 技能查看奖励
// s1 魂灯累积奖励
// f1 每日分享页面
// m1 每日十二章地图胜利
// j1 每日竞技/出征地图累计（击杀 助攻）10个
// c2 登录签到1次
// hr1 使用英雄参与竞技/出征地图累计击杀5人
// hr2 队伍使用英雄参与竞技/出征胜利1局
// hr3 使用英雄累计三天
// t06 游戏累积签到7天

export const apiUserInfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryplayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiScoreInfo = p => get(user_api.score_info, p);
export const apiTaskInfo = p => get(user_api.task_info, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const apiTeamInfo = p => get(user_api.team_info, p);
export const apiTeamCreate = p => get(user_api.team_create, p);
export const apiTeamJoin = p => get(user_api.join_apply, p);
export const apiShare = p => get(user_api.share, p);
export const apiInvite = p => get(user_api.invite, p);
export const apiInviteApply = p => post(user_api.invite_apply, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiApplyAgree = p => post(user_api.apply_agree, p);
export const apiTeamtask = p => get(user_api.task_team, p);
export const apiTeamtaskApply = p => post(user_api.team_task_apply, p);
export const apiApplyInfo = p => get(user_api.team_info, p);
export const apiRead = p => get(user_api.read, p);
export const apiReadUpdate = p => get(user_api.read_update, p);
export const apiShareApply  = p => get(user_api.share_apply, p);
export const apiQuit  = p => get(user_api.team_quit, p); 